export default __webpack_public_path__ + "static/media/icon.6c505d5d.png";